import React from "react";
import MainFAQs from "../components/MainFAQs";
import HeaderCities from "../components/HeaderCities";
import ReviewsSlider from "../components/ReviewsSlider";
import LazyImage from "../components/LazyImage";
import "../assets/css/service.css";

function JunkDroidServices() {
  return (
    <div>
      <head>
        <base href="/" />

        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Explore our junk removal services at Junk Droid! We haul furniture, appliances, debris, and more—fast, reliable, and eco-friendly. Get a free quote today!"
        />
        <link
          rel="preload"
          as="image"
          href="/assets/img/Junk-Removal-Santa-Clara.webp"
          type="image/webp"
        />
        <link rel="canonical" href="https://junkdroid.com/services/" />
        <title>Junk Removal Services | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid p-0 mb-0 madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Location</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Services
                    </li>
                  </ol>
                </nav>
                <h1>
                  Junk Removal <span>Services</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img
                    src="/assets/img/Junk-Removal-Santa-Clara.webp"
                    alt="Service santa clara"
                  />
                </div>
                <p>
                  Trust Junk Droid to handle all your junk removal needs quickly
                  and efficiently! Junk Droid is the go-to expert for reliable,
                  eco-friendly junk removal services. Homeowners and businesses
                  alike count on us for fast, professional hauling and disposal
                  solutions.
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="/book-online/">
                      <button type="button" className="btn btn-book">
                        Book Appointment{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                        </svg>
                      </button>
                    </a>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <LazyImage
                  src="/assets/img/Junk-Removal-Santa-Clara.webp"
                  alt="Service santa clara"
                />
              </div>
            </div>
          </div>
          <hr className="mb-0" />
        </div>

        {/* ================== Hero Section End HERE =========================  */}
        {/*  ================== yellow banner section start from here  ================== */}
        <div className="container-fluid yellow-desc section-yellow mt-0">
          <div className="col-md-12">
            <p className="mb-0">
              Free Estimates &amp; Same-Day Service Available
            </p>
          </div>
        </div>
        {/*  ================== yellow banner section ended from here  ================== */}
        {/* ================== Tabs Section Start HERE =========================  */}
        <div className="container-fluid">
          <div className="container junk-container service-sec tabs-section">
            <div className="row">
              <div className="col-md-12">
                <h2>Junk Droid Services</h2>
                <div className="line-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/estate-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Estate Cleanout"
                        src="/assets/img/house-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Estate <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/office-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Office Cleanout"
                        src="/assets/img/office-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Office <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/storage-unit-cleanouts/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Storage Unit Cleanout"
                        src="/assets/img/storage-unit-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Storage <br />
                      Unit Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/shed-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Shed Removal"
                        src="/assets/img/shed-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Shed <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/appliance-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Appliance Removal"
                        src="/assets/img/appliance-img.webp"
                      />
                    </div>
                    <h4>
                      Appliance <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/apartment-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Appartment Cleanout"
                        src="/assets/img/appartment-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Apartment <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/attic-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Attic Cleanout"
                        src="/assets/img/attic-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Attic <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/cardboard-pickup/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Cardboard Recycling"
                        src="/assets/img/cardboard-img.webp"
                      />
                    </div>
                    <h4>
                      Cardboard <br />
                      Recycling
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/carpet-disposal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Carpet Removal"
                        src="/assets/img/carpet-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Carpet <br />
                      Disposal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/concrete-pickup/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Concrete Removal"
                        src="/assets/img/concrete-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Concrete <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/construction-debris-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Construction Waste Removal"
                        src="/assets/img/construction-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Construction <br />
                      Waste <br /> Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/electronic-junk-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Electronics Junk Removal"
                        src="/assets/img/electronics-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Electronics <br />
                      Junk <br /> Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/foreclosure-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Foreclosure Cleanout"
                        src="/assets/img/foreclosure-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Foreclosure <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/furniture-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Furniture Removal"
                        src="/assets/img/furniture-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Furniture <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/garage-cleanout/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Garage Cleanout"
                        src="/assets/img/garage-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Garage <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/hot-tub-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Hot Tub Removal"
                        src="/assets/img/hottub-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Hot Tub <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/piano-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Piano Removal"
                        src="/assets/img/piano-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Piano <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/scrap-metal-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Scrap Metal Removal"
                        src="/assets/img/scrap-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Scrap <br />
                      Metal <br /> Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/shed-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Shed Removal"
                        src="/assets/img/shed-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Shed <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/yard-waste-removal/">
                  <div class="slider-service">
                    <div class="service-img-sec">
                      <img
                        alt="Yard Waste Removal"
                        src="/assets/img/yard-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Yard Waste <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/swing-set-removal/">
                  <div class="slider-service last-sec last-sect">
                    <div class="service-img-sec">
                      <img
                        alt="Playset Removal"
                        src="/assets/img/playset-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Playset <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/deck-demolition/">
                  <div class="slider-service last-sec last-sect">
                    <div class="service-img-sec">
                      <img
                        alt="Deck Removal"
                        src="/assets/img/deck-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Deck <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/fencing-removal/">
                  <div class="slider-service last-sec">
                    <div class="service-img-sec">
                      <img
                        alt="Fencing Removal"
                        src="/assets/img/fence-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Fencing <br />
                      Removal
                    </h4>
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <a href="/services/hoarder-cleanout/">
                  <div class="slider-service last-sec">
                    <div class="service-img-sec">
                      <img
                        alt="Hoarder Cleanout"
                        src="/assets/img/hoarder-img-icon.webp"
                      />
                    </div>
                    <h4>
                      Hoarder <br />
                      Cleanout
                    </h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* ================== Tabs Section End HERE =========================  */}
        {/* Leave Junk Section Start From HERE */}
        <div className="container-fluid leave-junk-pros">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 junk-pros">
                <h2>Leave Junk Hauling to Pros</h2>
                <h6>Turning Clutter Into Clean Spaces, Every Time!</h6>
                <div class="sliderline-svg junk-line">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="4"
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    ></path>
                  </svg>
                </div>
                <h3>Free Estimates</h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  You’ll always get a free, no-obligation estimate before any
                  work begins
                </p>
                <h3>Same-Day or Next-Day Service</h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Perfect for homes and businesses looking to remove junk, our
                  service keeps your space tidy and ready to use.
                </p>
                <h3>Five Star Service Guarantee</h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  If you're not completely satisfied with any aspect of our
                  service, please inform us, and we’ll make every effort to
                  resolve the issue promptly.
                </p>
                <h3>Professional Junk Haulers</h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Our team consists of skilled, highly trained, and certified
                  junk removal professionals equipped to handle any job. They
                  are dedicated to delivering an exceptional customer experience
                  every time.
                </p>
              </div>
              <div className="col-lg-5 col-md-12">
                <div className="d-flex flex-column gap-5">
                  <LazyImage
                    src="/assets/img/leave-junk.webp"
                    alt="leave junk"
                  />
                  <LazyImage
                    src="/assets/img/leave-junk2.webp"
                    alt="leave junk"
                    className="clean-junk"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Leave Junk Section Ended From HERE */}
        {/* ================== Top Rated Reviews Section Start HERE =========================  */}
        <ReviewsSlider />
        {/* ================== Top Rated Reviews Section End HERE =========================  */}
        {/* FAQ's Section Start HERE */}
        <div className="container-fluid faqs-junk service-footer-sec">
          <div className="container faq-sec">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h2>
                    Frequently <span>Asked Questions</span>
                  </h2>
                  <div className="sliderline-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={64}
                      height={4}
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                        fill="#60BDFF"
                      />
                    </svg>
                  </div>
                </div>
                {/* FAQ */}
                <MainFAQs />
                {/* FAQ */}
              </div>
            </div>
          </div>
          {/* Booking Section Start From Here */}
          <div className="container upr-footer up-footer booking-footer">
            <div className="row">
              <div className="col-md-12">
                <h2>Book Online and Save $20</h2>
                <h6>
                  We’ll do&nbsp;all the lifting and loading, plus clean
                  up&nbsp;any mess afterwards
                </h6>
                <center>
                  <a href="/book-online/">
                    <button type="button" className="btn up-footer-btn">
                      SCHEDULE ONLINE &nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-calendar"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                      </svg>
                    </button>
                  </a>
                </center>
              </div>
            </div>
          </div>
          {/* Booking Section Ended From Here */}
        </div>
        {/* FAQ's Section End HERE */}
      </>
    </div>
  );
}

export default JunkDroidServices;
